import MemoizedStars from '../../Components/stars/memoizedStars.component'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import ImageNotFound from './Images/page_not_found.png'
import { ButtonLink, Container, MainContainer } from './PageNotFound.style'
export default function PageNotFound() {
  return (
      <Container>
          <Header />
          <MainContainer>
              <div className="image_wrapper">
                  <img src={ImageNotFound} alt="page_not_found" className='image' />
                  <MemoizedStars/>
              </div>
              <div className="message_box">
                <p className='error_heading'>Error</p>
                  <div className="not_found_numbers">
                      <p className="first_number">4</p>
                      <p className="second_number">0</p>
                      <p className="third_number">4</p>
                  </div>
                  <p className="message">
                      Sorry, the page you are looking for does not exist.
                  </p>
              </div>
              <ButtonLink to={'/'}>
                  Go to Homepage
              </ButtonLink>
          </MainContainer>
          <div className="footer_container">
              <Footer />
          </div>
      </Container>
  )
}
